import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCpVH0bQwc_2v_99MYtD5ZWwJEO0FDmN2k",
  authDomain: "school-erp-wala.firebaseapp.com",
  projectId: "school-erp-wala",
  storageBucket: "school-erp-wala.firebasestorage.app",
  messagingSenderId: "493932182507",
  appId: "1:493932182507:web:9e90240eea63c94b8a37ae",
  measurementId: "G-YC363MW4R9"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
